import { decodePolyline } from './mapGeometry';
import { stripStopSuffix } from '../../../utils/composeDriverRecords';

// Shared path geometry for the Monitoring route maps: chaining stops into
// polyline positions (road geometry per leg when the traffic data supports
// it, chords otherwise).

export const MIN_LINE_POINTS = 2;

export const hasCoords = (stop) =>
  Number.isFinite(stop.latitude) && Number.isFinite(stop.longitude);

const toLatLng = (stop) => [stop.latitude, stop.longitude];

// Road geometry for the leg INTO `to`, or null when no polyline exists or
// the leg was driven from a different stop than the line connects.
function roadPointsInto(to, from) {
  if (!to.legPolyline || !to.legOrigin || !from.stopId) {
    return null;
  }
  if (stripStopSuffix(to.legOrigin) !== stripStopSuffix(from.stopId)) {
    return null;
  }
  const decoded = decodePolyline(to.legPolyline);
  return decoded.length >= MIN_LINE_POINTS ? decoded : null;
}

// Chain stops into one positions array, road geometry per segment when the
// leg data supports it. Stop coordinates anchor every joint, so a missing
// polyline degrades that segment to a chord without breaking continuity.
export function buildPathPositions(stops) {
  if (stops.length === 0) {
    return [];
  }
  const positions = [toLatLng(stops[0])];
  for (let i = 1; i < stops.length; i += 1) {
    const road = roadPointsInto(stops[i], stops[i - 1]);
    if (road) {
      positions.push(...road);
    }
    positions.push(toLatLng(stops[i]));
  }
  return positions;
}
